'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useMemo } from 'react';
import { z } from 'zod';
import { HStack } from '@/components/Layout';
import { getDeviceFormStoreContext } from '../../-store/deviceFormStoreContext';
import CatalogInnerNavigation from './-components/CatalogInnerNavigation';
import { CatalogManualForm } from './-components/CatalogManualForm';
import { CatalogProgressCard } from './-components/CatalogProgressCard';
import { useCatalogDeviceType } from './-hooks/useCatalogDeviceType';
const CatalogSearchSchema = z.object({
  catalogId: z.string()
});
export const Route = createFileRoute('/_staff/devices/add/catalog/$deviceType/')({
  validateSearch: zodValidator(CatalogSearchSchema),
  component: CatalogForm
});
function CatalogForm() {
  const {
    deviceType
  } = useCatalogDeviceType();
  const {
    context
  } = getDeviceFormStoreContext(deviceType);
  const store = useMemo(() => context.createStore(), [context]);
  const {
    catalogId
  } = Route.useSearch();
  return <context.Provider value={store}>
      <HStack className="w-full p-6 gap-6">
        <div className="shrink-0">
          <CatalogInnerNavigation catalogId={catalogId} />
        </div>
        <CatalogManualForm className="grow min-w-[340px]" catalogId={catalogId} />
        <div className="shrink-0">
          <CatalogProgressCard />
        </div>
      </HStack>
    </context.Provider>;
}